// Create a function that determins if there is an endDate if there isn't then determine if the startDate is  30Days, 90Days, or 12 Months from today
// if it is then return "30 Days", "90 Days", or "12 Months", if startDate is missing then return "Overall"

export const determineDateRange = (startDate: Date | undefined, endDate: Date | undefined, value: string) => {
	if (value === "30") {
		return "30 Days";
	}
	if (value === "90") {
		return "90 Days";
	}
	if (value === "year") {
		return "12 Months";
	}

	if (value === "all") {
		return "Overall";
	}

	if (startDate) {
		if (endDate) {
			// return date range startDate to endDate
			return `${startDate.toLocaleDateString("en-US", {
				month: "long",
				day: "numeric",
				year: "numeric",
			})}  - ${endDate.toLocaleDateString("en-US", {
				month: "long",
				day: "numeric",
				year: "numeric",
			})}`;
		}
	}

	return "";
};
